import script from "./SimpleSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimpleSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./SimpleSwitch.vue?vue&type=style&index=0&id=c61986f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c61986f0"]])

export default __exports__